import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'decimal-formatted-column',
  template: '<span *ngIf="text">{{text}}</span>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DecimalFormattedColumnComponent implements OnInit {

  @Input()
  searchTerm;
  @Input()
  columnValue;
  @Input()
  columnData;

  text: string;

  constructor() { }

  ngOnInit() {
    const val: number = this.columnValue[this.columnData.columnName];
    const formatter = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2});
    this.text = formatter.format(val);
  }
}
